import { render, staticRenderFns } from "./EntryCompanyWiseCandidateReport.vue?vue&type=template&id=484f0551&scoped=true&"
import script from "./EntryCompanyWiseCandidateReport.vue?vue&type=script&lang=js&"
export * from "./EntryCompanyWiseCandidateReport.vue?vue&type=script&lang=js&"
import style0 from "./EntryCompanyWiseCandidateReport.vue?vue&type=style&index=0&id=484f0551&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484f0551",
  null
  
)

export default component.exports